import React from 'react';

import HtmlRenderer from '@/components/HtmlRender';
import cn from '@/helpers/utils/classNames';

import { HeadingProps } from '../propTypes';
import { headingStyles } from '../styles';

// leading-8 xs:text-[1.5rem] xs:leading-6 xxs:text-[1.25rem]
const HeadingTwo = ({ className, variant = 'primary', children, ...rest }: HeadingProps) => {
  if (rest.dangerouslySetInnerHTML?.__html)
    return (
      <HtmlRenderer
        {...rest}
        className={cn(
          headingStyles({
            color: variant,
          }),
          'text-[28px]  leading-[33px] sm:text-2xl lg:text-[36px] lg:leading-[46px] ',
          className
        )}
        as="h2"
        html={rest.dangerouslySetInnerHTML.__html}
      />
    );

  return (
    <h2
      className={cn(
        headingStyles({
          color: variant,
        }),
        'text-[28px]  leading-[33px] sm:text-2xl lg:text-[36px] lg:leading-[46px] ',
        className
      )}
      {...rest}
    >
      {children}
    </h2>
  );
};

export default HeadingTwo;
